import React, { useState, Fragment, useEffect } from 'react';
import { useFormikContext } from 'formik';
import withErrorHandler from '../../../../../hoc/withErrorHandler/withErrorHandler';
import { ShowGetImage } from '../../../../../common/components/ShowGetImage/ShowGetImage';
import GlobalUploadComp from '../../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../../../images/icons/upload_new.svg';
import {
  companyPanUpload,
  companyPanOcr,
  UploadFileToS3,
  getCompanyPan,
  verifyCompanyPan
} from '../../../../../common/constants/api';
import PopUp from '../../../../../common/components/PopUp/PopUp';
import classes from './CompanyPan.module.css';

import _ from 'lodash';

import { getApplicantionInfo } from '../../../../../common/utils/applicantionInfo';
import CommonDatePicker from '../../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import CommonInput from '../../../../../components/Dashboard-res/CommonComponent/CommonInput';
import moment from 'moment';
import get from 'lodash/get';
import { Append_0 } from '../../../../../common/constants/Append_0';
import CircularLoading from '../../../../../common/components/CircularLoading/CircularLoading';

export const loading = () => (
  <div className="w-full flex content-center items-center relative -ml-10 ">
    <div className="absolute inset-1/2 mt-40 ">
      <CircularLoading />
    </div>
  </div>
);

const CompanyPan = () => {
  const [isGetOver, setIsGetOver] = useState(false);
  const [editPan, setEditPan] = useState(false);
  const [getPanDoc, setPanDoc] = useState('');
  const [isOcr, setIsOcr] = useState(false);
  const [ocrData, setOcrData] = useState('');
  const [userData, setUserData] = useState('');
  const [show, setShow] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [verifyingPan, setVerifyingPan] = useState(false);

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    validateForm,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    resetForm
  } = useFormikContext();

  useEffect(() => {
    validateForm();
    if (editPan) {
      setOcrData('');
      setUserData('');
      setPanDoc('');
      setFieldValue('isGetValues', false);
      resetForm();
      validateForm();
    }
  }, [editPan]);

  useEffect(() => {
    const myAsync = async () => {
      setIsGetOver(false);
      let data = getApplicantionInfo();
      const { leadId, leadApplicantId } = data;
      await getCompanyPan(leadId, leadApplicantId)
        .then(data => {
          console.log(data);
          if (data.links.length === 0) {
            setIsGetOver(true);
          } else {
            setFieldValue('isGetValues', true);
            let { links, userData } = data;
            setPanDoc(links[0].url);
            setUserData(userData);
            setIsGetOver(true);
          }
        })
        .catch(err => setIsGetOver(true));
    };
    myAsync();
  }, []);

  // setting up the get values

  useEffect(() => {
    if (userData) {
      setFieldValue('companyName', userData?.name);
      setFieldValue('panNumber', userData?.panNumber);
      const breakTheDate = userData?.doi.toString().split('-');
      setFieldValue('regisDate.year', {
        value: breakTheDate[0],
        label: breakTheDate[0]
      });

      setFieldValue('regisDate.month', {
        value: breakTheDate[1],
        label: breakTheDate[1]
      });
      setFieldValue('regisDate.date', {
        value: breakTheDate[2],
        label: breakTheDate[2]
      });
      setTimeout(() => {
        validateForm();
      }, 1000);
    }
  }, [userData]);

  useEffect(() => {
    if (values.file[0] && values.file[0][0]) {
      companyPanUpload(
        getApplicantionInfo().leadId,
        getApplicantionInfo().leadApplicantId
      )
        .then(res => {
          setShow(true);
          setIsOcr(true);
          let { url, fileName, requestId } = res;
          UploadFileToS3(url, values.file[0][0], {
            'Content-Type': `${values.file[0][0].type}`
          })
            .then(res => {
              companyPanOcr(
                getApplicantionInfo().leadId,
                getApplicantionInfo().leadApplicantId,
                requestId
              )
                .then(data => {
                  const { kycEntries } = data;
                  setOcrData(kycEntries);
                  setFieldValue('companyName', kycEntries?.name?.value || '');
                  setFieldValue(
                    'panNumber',
                    kycEntries?.panNumber?.value || ''
                  );
                  const breakTheDate = kycEntries?.dob?.value
                    .toString()
                    .split('/');
                  setFieldValue('regisDate.year', {
                    value: breakTheDate[2],
                    label: breakTheDate[2]
                  });

                  setFieldValue('regisDate.month', {
                    value: breakTheDate[1],
                    label: breakTheDate[1]
                  });
                  setFieldValue('regisDate.date', {
                    value: breakTheDate[0],
                    label: breakTheDate[0]
                  });
                  setIsOcr(false);
                  setShow(false);
                  setTimeout(() => {
                    validateForm();
                  }, 1000);
                })
                .catch(err => {
                  setIsOcr(false);
                  setShow(false);
                });
            })
            .catch(err => {
              setIsOcr(false);
              setShow(false);
            });
        })
        .catch(err => {
          setIsOcr(false);
          setShow(false);
        });
    }
    return () => {
      setIsOcr(false);
      setShow(false);
    };
  }, [values.file[0]]);

  const submitHandler = () => {
    setShow(true);
    setVerifyingPan(true);
    setIsPanVerified(false);
    verifyCompanyPan(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      {
        name: values.companyName,
        panNumber: values.panNumber,
        doi:
          values.regisDate.year.value +
          '-' +
          values.regisDate.month.value +
          '-' +
          values.regisDate.date.value
      }
    )
      .then(res => {
        setIsPanVerified(true);
        setVerifyingPan(false);
        setTimeout(() => {
          handleSubmit();
        }, 2000);
      })
      .catch(err => {
        setShow(false);
        setVerifyingPan(false);
        setIsPanVerified(false);
      });
  };

  const propsRenderer = () => {
    let props = {};
    if (isOcr) {
      props.type = 'loading';
      props.text = 'Fetching information please wait. .';
      props.dontClose = true;
      return props;
    }
    if (isPanVerified) {
      props.type = 'success';
      props.text = 'PAN verified successfully. . ';
      props.dontClose = true;
      return props;
    }
    if (verifyingPan) {
      props.type = 'loading';
      props.text = 'Verifying PAN please wait. . ';
      props.dontClose = true;
      return props;
    }
  };

  if (isGetOver) {
    return (
      <Fragment>
        {show && <PopUp {...propsRenderer()} setShow={setShow} show={show} />}
        <div className=" bg-transparent md:bg-white mx-auto md:ml-0 md:mr-auto min-h-screen">
          <div className=" w-11/12    md:max-w-full  md:w-full  md:p-5 mx-auto">
            <h1 className="text-black-400 font-roboto font-semibold text-base text-center mb-3">
              Company PAN Card
            </h1>

            {/* /////////upload */}
            <div className="flex  justify-center  md:flex-wrap">
              {getPanDoc && !editPan ? (
                <div className="ml-2 mt-2">
                  <ShowGetImage img={getPanDoc} setEdit={setEditPan} />
                </div>
              ) : (
                <div className="mr-4">
                  <div
                    className="bg-white  rounded-lg border border-navy-200 md:border-none
            py-9 pl-11 pr-5 md:py-0 md:pl-0 md:pr-0 mx-auto
            "
                  >
                    <GlobalUploadComp
                      data={values}
                      imgIndex={0} // 0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      initialImg={initialImg} // initial image
                      subInst="Click here to upload your Company PAN"
                      subtext="CHOOSE FILE"
                    />
                  </div>
                </div>
              )}
            </div>
            {/* {(fileUploaded || (s3Img && s3Img.length > 0)) && ( */}
            {(ocrData || userData || getPanDoc) && (
              <div
                className={
                  classes.form_inputs +
                  ' w-full p-2 px-4 flex flex-col md:flex-row md:flex-wrap md:max-w-3xl items-center md:mt-5 justify-center  mx-auto'
                }
              >
                <div className=" md:w-80 w-full  my-4 mx-2 ">
                  <CommonInput
                    name="companyName"
                    id="companyName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.companyName}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Company Name"
                    error={
                      (touched?.companyName || '') &&
                      (errors?.companyName || '')
                    }
                    errorMsg={errors?.companyName || ''}
                    touched={touched?.companyName || ''}
                  />
                </div>
                <div className="md:w-80 w-full my-4 mx-2">
                  <CommonInput
                    name="panNumber"
                    id="panNumber"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.panNumber}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="PAN Number"
                    error={
                      (touched?.panNumber || '') && (errors?.panNumber || '')
                    }
                    errorMsg={errors?.panNumber || ''}
                    touched={touched?.panNumber || ''}
                  />
                </div>
                <div className={'my-8 md:w-80 w-full mx-2 '}>
                  <div className=" absolute -mt-6 text-grey-1003 text-sm">
                    Registration Date
                  </div>
                  <CommonDatePicker
                    minYear={'1900'}
                    maxYear={moment().format('YYYY')}
                    onChangeMonth={(value, isValidDate) => {
                      if (value.label !== 'Month') {
                        setFieldValue(
                          'regisDate.month',
                          {
                            value: Append_0(value.value, 2),
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('regisDate.month', true, false);
                      }
                      if (value.label === 'Month') {
                        setFieldValue(
                          'regisDate.month',
                          {
                            value: '',
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('regisDate.month', true, false);
                      }
                      if (!isValidDate) {
                        setFieldValue(
                          'regisDate.month',
                          {
                            value: '',
                            label: 'Month'
                          },
                          true
                        );
                        setFieldTouched('regisDate.month', true, true);
                      }
                    }}
                    onChangeYear={(value, isValidDate) => {
                      if (value.label !== 'Year') {
                        setFieldValue(
                          'regisDate.year',
                          {
                            value: value.value,
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('regisDate.year', true, false);
                      }

                      if (!isValidDate) {
                        setFieldValue(
                          'regisDate.year',
                          {
                            value: '',
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('regisDate.year', true, true);
                      }
                    }}
                    onChangeDate={value => {
                      if (value.label !== 'Date') {
                        setFieldValue(
                          'regisDate.date',
                          {
                            value: Append_0(value.value, 2),
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('regisDate.date', true, true);
                      } else {
                        setFieldValue(
                          'regisDate.date',
                          {
                            value: '',
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('regisDate.date', true, true);
                      }
                    }}
                    valueMonth={values.regisDate.month}
                    valueYear={values.regisDate.year}
                    valueDate={values.regisDate.date}
                    errorYear={get(errors, 'regisDate.year', false)}
                    touchedYear={touched?.regisDate?.year || false}
                    onBlurYear={() => {
                      setFieldTouched('regisDate.year', true, true);
                    }}
                    errorMonth={get(errors, 'regisDate.month', false)}
                    touchedMonth={touched?.regisDate?.month || ''}
                    onBlurMonth={() => {
                      setFieldTouched('regisDate.month', true, true);
                    }}
                    errorDate={get(errors, 'regisDate.date', false)}
                    touchedDate={touched?.regisDate?.date || ''}
                    onBlurDate={() => {
                      setFieldTouched('regisDate.date', true, true);
                    }}
                    errorMsg={
                      (touched?.regisDate?.date && errors['regisDate.date']) ||
                      (touched?.regisDate?.month &&
                        errors['regisDate.month']) ||
                      (touched?.regisDate?.year && errors['regisDate.year'])
                    }
                  />
                </div>
              </div>
            )}
            <button
              disabled={!_.isEmpty(errors)}
              type={'button'}
              onClick={submitHandler}
              className=" submitButton text-14 w-56 h-12 font-medium  font-roboto"
            >
              Save & Verify
            </button>

            {/* )} */}
          </div>
        </div>
      </Fragment>
    );
  } else return loading();
};

export default withErrorHandler(CompanyPan);
